import Table from "../../../../../Components/Table";
import { ColumnDescription } from "react-bootstrap-table-next";
import { IContato } from "../../../../../Interfaces/Automacao/Audiencia/AudienciaInterfaces";
import ModalFiltroContatos from "./ModalFiltroContatos";
import StickyToolbar from "../../../../../Components/StickyToolbar";
import { formatMoneyReais } from "../../../../../Tools/FormatTools";
import { useVincularDesvincularContatos } from "./useVincularDesvincularContatos";

export default function VincularDesvincularContatos() {
    const {
        totalPaginas,
        setListIdEmpreedimento,
        setLstIdContatoSelected,
        VincularDesvicularContato,
        loading,
        location,
        filter,
        listIdEmpreedimento,
        filtroInicial,
        lstContato,
        updateList,
        filtroGestaoStorage,
        setPage,
    } = useVincularDesvincularContatos();

    const tableViewColumns: Array<ColumnDescription<IContato>> = [
        {
            dataField: "DS_NOME",
            text: "Cliente / Contato",
            headerClasses: "font-size-h8 font-weight-bold",
            formatter: (c, row) => (
                <div>
                    <h5>{row.DS_NOME}</h5>
                </div>
            ),
        },
        {
            dataField: "VGV_TOTAL",
            text: "Valor Geral de Venda Total",
            formatter: (c, row) => (
                <div>
                    <span>{formatMoneyReais(row.VGV_TOTAL)}</span>
                </div>
            ),
            headerClasses: "font-size-h8 font-weight-bold",
        },
        {
            dataField: "DS_EMPREENDIMENTO",
            text: "Empreendimento",
            headerClasses: "font-size-h8 font-weight-bold",
            formatter: (c, row) => (
                <div>
                    <span>{row.DS_EMPREENDIMENTO}</span>
                </div>
            ),
        },
        {
            dataField: "DS_TIPO_CONTA",
            text: "Tipo de Conta",
            headerClasses: "font-size-h8 font-weight-bold",
            formatter: (c, row) => (
                <div>
                    <span>{row.DS_TIPO_CONTA}</span>
                </div>
            ),
        },
        {
            dataField: "DS_PERFIL_FINANCEIRO_CONTA",
            text: "Perfil Financeiro da Conta",
            headerClasses: "font-size-h8 font-weight-bold",
        },
        {
            dataField: "DS_ETAPA_JORNADA",
            text: "Etapa Jornada",
            headerClasses: "font-size-h8 font-weight-bold",
        },
        {
            dataField: "NR_UNIDADES",
            text: "Quantidades Unidades",
            headerClasses: "font-size-h8 font-weight-bold",
        },
    ];

    return (
        <>
            <div className="card card-custom p-10">
                <div className="card-header border-0 pt-5 mb-5">
                    <h4 className="card-title align-items-start flex-column">
                        {location.pathname.split("/")[2] === "VincularContatos"
                            ? "Vincular Contatos"
                            : "Desvincular Contatos"}
                    </h4>
                    <div className="card-toolbar">
                        <StickyToolbar>
                            <ModalFiltroContatos
                                filter={{
                                    ...filter,
                                    ID_EMPREENDIMENTO: listIdEmpreedimento,
                                }}
                                idEmpreendimento={listIdEmpreedimento}
                                filtroGestaoStorage={filtroGestaoStorage}
                                setIdEmpreendimento={setListIdEmpreedimento}
                                filtroInicial={filtroInicial}
                                updateList={updateList}
                            />
                        </StickyToolbar>
                    </div>
                </div>
                <div className="card-body pt-2 pb-0 mt-n3">
                    <div className="table-responsive-sm">
                        <Table
                            keyField="ID"
                            columns={tableViewColumns}
                            wrapperClasses="mw-100"
                            tableView={{
                                columns: tableViewColumns,
                                sizePerPage: 10,
                                cancelYScroll: true,
                                striped: true,
                            }}
                            remote={{ pagination: true }}
                            data={lstContato || []}
                            onTableChange={(type, newState) => {
                                setPage(newState.page);
                            }}
                            noSearch
                            loading={loading}
                            totalPages={totalPaginas}
                            classes="tableClass"
                            rowClasses="checkbox-table"
                            bodyClasses="bodyClass"
                            noDataIndication={() => (
                                <div className="text-black-50 text-center">
                                    Nenhuma Contato encontrada
                                </div>
                            )}
                            selectRow={{
                                mode: "checkbox",
                                clickToSelect: true,
                                clickToEdit: true,
                                onSelect: (row, isSelect) => {
                                    if (isSelect) {
                                        setLstIdContatoSelected((id) => [
                                            ...id,
                                            row.ID_CONTATO,
                                        ]);
                                    } else {
                                        setLstIdContatoSelected((lstId) =>
                                            lstId.filter(
                                                (id) => id !== row.ID_CONTATO
                                            )
                                        );
                                    }
                                },
                                onSelectAll: (isSelect, rows) => {
                                    if (isSelect) {
                                        setLstIdContatoSelected(
                                            (idsContatos) => [
                                                ...idsContatos,
                                                ...rows.map(
                                                    (contatos) =>
                                                        contatos.ID_CONTATO
                                                ),
                                            ]
                                        );
                                    } else {
                                        setLstIdContatoSelected([]);
                                    }
                                },
                            }}
                            rowStyle={{ height: 80 }}
                            defaultStyle={{ align: "center" }}
                            striped={false}
                        />
                    </div>
                </div>
                <div className="card-body col-6 d-flex align-self-center justify-content-center mt-3">
                    <button
                        className="btn btn-block btn-outline-success mt-2"
                        onClick={VincularDesvicularContato}
                    >
                        {location.pathname.split("/")[2] === "VincularContatos"
                            ? "Vincular Contatos"
                            : "Desvincular Contatos"}
                    </button>
                </div>
            </div>
        </>
    );
}
